import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("db_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("db_token", data.access_token);
    const meResp = await api.get("/auth/me");
    localStorage.setItem("db_user", JSON.stringify(meResp.data));
    setUser(meResp.data);
    return meResp.data;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("db_token");
    localStorage.removeItem("db_user");
    setUser(null);
  }, []);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("db_token");
    if (!token) return null;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("db_user", JSON.stringify(data));
      return data;
    } catch {
      return null;
    }
  }, []);

  useEffect(() => {
    // On first load, refresh /me silently if a token exists.
    const token = localStorage.getItem("db_token");
    if (!token || user) return;
    setLoading(true);
    api.get("/auth/me").then((r) => {
      setUser(r.data);
      localStorage.setItem("db_user", JSON.stringify(r.data));
    }).catch(() => {
      localStorage.removeItem("db_token");
    }).finally(() => setLoading(false));
  }, [user]);

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
